/**
 * useCheckoutFlow — state machine de navigation du checkout panier.
 *
 * Extrait de CartCheckoutModal.jsx (Lot 8b §71 zone gelée §13/§46).
 * Gère : step courant, méthode sélectionnée, état loading, erreur, résultat.
 *
 * 5 états extraits de CartCheckoutModal.jsx :
 *   - step          (useState STEP.REVIEW)
 *   - selectedMethod (useState null)
 *   - loadingIntent  (useState false)
 *   - error          (useState null)
 *   - result         (useState null)
 *
 * §9 DRY — responsabilité unique : navigation + état général checkout.
 * §52 — testable via tests/unit/hooks/useCheckoutFlow.test.js.
 */
import { useState, useCallback } from 'react';

export const STEP = {
  REVIEW: 'REVIEW',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  PROCESSING: 'PROCESSING',
  RESULT: 'RESULT',
};

/**
 * @returns {{
 *   step: string,
 *   setStep: Function,
 *   selectedMethod: string|null,
 *   setSelectedMethod: Function,
 *   loadingIntent: boolean,
 *   setLoadingIntent: Function,
 *   error: string|null,
 *   setError: Function,
 *   result: Object|null,
 *   setResult: Function,
 *   reset: Function,
 *   STEP: Object,
 * }}
 */
export function useCheckoutFlow() {
  const [step, setStep] = useState(STEP.REVIEW);
  const [selectedMethod, setSelectedMethod] = useState(null); // 'stripe' | 'paypal' | 'crypto'
  const [loadingIntent, setLoadingIntent] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null); // { status, completed, failed }

  /** Remet tous les états à leur valeur initiale (appelé à handleClose). */
  const reset = useCallback(() => {
    setStep(STEP.REVIEW);
    setSelectedMethod(null);
    setLoadingIntent(false);
    setError(null);
    setResult(null);
  }, []);

  return {
    step,
    setStep,
    selectedMethod,
    setSelectedMethod,
    loadingIntent,
    setLoadingIntent,
    error,
    setError,
    result,
    setResult,
    reset,
    STEP,
  };
}

export default useCheckoutFlow;
